import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import useLogout from "hooks/useLogout";
/**
 * @param onIdle - function to notify user when idle timeout is close
 * @param idleTime - number of seconds to wait before user is logged out
 */

const useIdleTimeout = ({ onMessage, onIdle, idleTime = 900 }) => {
  const { portalLogout } = useLogout();
  // default 15 minutes idle timeout
  const idleTimeout = 1000 * idleTime;
  const [isIdle, setIdle] = useState(false);
  let promptBeforeIdle = 120 * 1000; // show a popup 2 minutes before the end of the session

  if (promptBeforeIdle >= idleTimeout) {
    promptBeforeIdle = idleTimeout / 2;
  }

  const handleIdle = () => {
    setIdle(true);
    portalLogout();
  };

  const idleTimer = useIdleTimer({
    onMessage: onMessage,
    timeout: idleTimeout,
    promptBeforeIdle: promptBeforeIdle,
    onPrompt: onIdle,
    onIdle: handleIdle,
    debounce: 500,
    crossTab: true,
    syncTimers: 200,
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
  };
};
export default useIdleTimeout;
